/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Faq_People_AInputs */

const en_mk_tb_faq_people_a = /** @type {(inputs: Mk_Tb_Faq_People_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Each developer uses their own local AI account and reports through the Bystep CLI or MCP. Claim a task, fetch current context, do the work, verify and submit for review. Claims coordinate ownership; they do not launch an AI or share subscriptions. Agent teams are a separate execution workflow.`)
};

const id_mk_tb_faq_people_a = /** @type {(inputs: Mk_Tb_Faq_People_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa. Setiap developer memakai akun AI sendiri di perangkatnya dan melapor lewat CLI atau MCP Bystep. Ambil tugas, unduh konteks terbaru, kerjakan, verifikasi, lalu ajukan review. Klaim mengatur penanggung jawab; klaim tidak menjalankan AI atau membagikan langganan. Tim agent memiliki alur eksekusi tersendiri.`)
};

/**
* | output |
* | --- |
* | "Yes. Each developer uses their own local AI account and reports through the Bystep CLI or MCP. Claim a task, fetch current context, do the work, verify and s..." |
*
* @param {Mk_Tb_Faq_People_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_faq_people_a = /** @type {((inputs?: Mk_Tb_Faq_People_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Faq_People_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_faq_people_a(inputs)
	return en_mk_tb_faq_people_a(inputs)
});